import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LockService } from '../../core/lock.service';

export const pinGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const lockService = inject(LockService);

  if (lockService.locked) {
    router.navigate(['/locked'], { queryParams: { redirectUrl: state.url } });
    return false;
  }

  return true;
};
